import { Observable } from "rxjs";
import { PersonalInformation } from "../personal-information.model";
import { IAPIResponse } from "@domain/interfaces/apis/api-response.interface";
import { PasswordChange } from "../password-change.model";
import { CreditCard } from "../credit-card.model";
import { User } from "../user.model";

export abstract class AccountSettingsGateway {
    abstract getPersonalInformation(userId: number): Observable<User>;
    abstract updatePersonalInformation(personalInformation: PersonalInformation): Observable<IAPIResponse>;
    abstract updateBillingInformation(creditCard: CreditCard): Observable<IAPIResponse>;
    abstract updatePassword(passwordChange: PasswordChange): Observable<IAPIResponse>;
}